const SvgKonstrukcjaRamiakowa60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="M24 26.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    <path fill="#373737" fillRule="evenodd" d="M15 2h30v56H15zm2 2v52h5V32h1.5v14.5h13v-33h-13V21H22V4zm19.5 44h-13v8h13zm0-44v8h-13V4zM38 4v52h5V4z" clipRule="evenodd" />
  </svg>;
export default SvgKonstrukcjaRamiakowa60;